import { useNavigateKeepingReferrerInfo } from '@monorepo/shared/hooks/navigation/useReferrerUrl';
import { NullableString } from 'mapistry-shared';
import { WizardStep, WizardStepUrlPart } from './consts';

type GetLinkToFormTemplateWizardStepParams = {
  stepToGoTo: WizardStep;
  formTemplateSlug: NullableString;
  formWizardBasePath: string;
};

export function getLinkToFormTemplateWizardStep({
  stepToGoTo,
  formTemplateSlug,
  formWizardBasePath,
}: GetLinkToFormTemplateWizardStepParams): string {
  const urlPart = WizardStepUrlPart[stepToGoTo];

  const urlEnding = urlPart ? `/${urlPart}` : '';

  return formTemplateSlug
    ? `${formWizardBasePath}/${formTemplateSlug}/edit${urlEnding}`
    : `${formWizardBasePath}/new${urlEnding}`;
}

export function useNavigateToFormTemplateWizardStep({
  formWizardBasePath,
  stepToGoTo,
  formTemplateSlug,
}: GetLinkToFormTemplateWizardStepParams) {
  const navigateKeepingReferrerInfo = useNavigateKeepingReferrerInfo();
  const linkToStep = getLinkToFormTemplateWizardStep({
    stepToGoTo,
    formTemplateSlug,
    formWizardBasePath,
  });
  return () => navigateKeepingReferrerInfo(linkToStep);
}
